/** 2 * π * 45 (quick-menu), 2 * π * 46 (fixed gototop) */
const CIRCUMFERENCE_QUICK = 283;
const CIRCUMFERENCE_FIXED = 289;

/**
 * Go To Top Component
 * - quick-menu 내부 버튼 (선택)
 * - 고정 플로팅 버튼 (좌측 하단, 스크롤 % 링)
 */
export class GoToTop {
    constructor() {
        this.root = null;
        this.button = null;
        this.progressFill = null;
        this.fixedWrap = null;
        this.fixedProgressFill = null;
        this.THRESHOLD = 200;
        this.ticking = false;
    }

    init() {
        const quickMenu = document.querySelector(".no-quick-menu");
        this.root = quickMenu?.querySelector(".no-quick-menu__gototop");
        this.button = quickMenu?.querySelector(".no-quick-menu__gototop-btn");
        this.progressFill = quickMenu?.querySelector(".no-quick-menu__gototop-progress-fill");
        if (this.root && this.button) {
            this.initAccessibility();
            this.bindEvents();
            this.toggle();
            this.updateProgress();
        }

        this.fixedWrap = document.querySelector("[data-gototop-wrap]");
        this.fixedProgressFill = this.fixedWrap?.querySelector("[data-gototop-progress]");
        if (this.fixedWrap) {
            this.bindScrollForFixed();
            this.toggle();
            this.updateProgress();
        }

        this.bindDataGototopButtons();
    }

    bindScrollForFixed() {
        const lenisInstance = window.lenis || (window.app?.utils?.lenis?.getInstance?.());
        if (lenisInstance) {
            lenisInstance.on("scroll", () => this.onScroll());
        } else {
            window.addEventListener("scroll", () => this.onScroll(), { passive: true });
        }
        window.addEventListener("resize", () => {
            this.toggle();
            this.updateProgress();
        }, { passive: true });
    }

    /**
     * [data-gototop] 버튼들에 스무스 스크롤 + 키보드 바인딩
     */
    bindDataGototopButtons() {
        document.querySelectorAll("[data-gototop]").forEach((btn) => {
            btn.addEventListener("click", () => this.scrollTopSmooth());
            btn.addEventListener("keydown", (e) => this.onKey(e));
        });
    }

    initAccessibility() {
        if (this.button) this.button.setAttribute("aria-label", "맨 위로 이동");
    }

    bindEvents() {
        // Lenis 스크롤 지원
        const lenisInstance = window.lenis || (window.app?.utils?.lenis?.getInstance?.());
        if (lenisInstance) {
            lenisInstance.on("scroll", () => this.onScroll());
        } else {
            window.addEventListener("scroll", () => this.onScroll(), {
                passive: true,
            });
        }
        
        window.addEventListener("resize", () => {
            this.onScroll();
            this.updateProgress();
        }, {
            passive: true,
        });
        this.button.addEventListener("click", () => this.scrollTopSmooth());
        this.button.addEventListener("keydown", (e) => this.onKey(e));
    }

    toggle() {
        const shouldShow = window.scrollY > this.THRESHOLD;
        if (this.root) {
            if (shouldShow) this.root.classList.add("is-visible");
            else this.root.classList.remove("is-visible");
        }
        if (this.fixedWrap) {
            if (shouldShow) {
                this.fixedWrap.classList.add("is-visible");
                this.fixedWrap.setAttribute("aria-hidden", "false");
            } else {
                this.fixedWrap.classList.remove("is-visible");
                this.fixedWrap.setAttribute("aria-hidden", "true");
            }
        }
    }

    onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            this.toggle();
            this.updateProgress();
            this.ticking = false;
        });
    }

    updateProgress() {
        const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const progress = scrollHeight <= 0 ? 0 : Math.min(scrollTop / scrollHeight, 1);
        const setOffset = (el, circumference) => {
            if (!el) return;
            el.style.strokeDashoffset = String(circumference * (1 - progress));
        };
        setOffset(this.progressFill, CIRCUMFERENCE_QUICK);
        setOffset(this.fixedProgressFill, CIRCUMFERENCE_FIXED);
    }

    scrollTopSmooth() {
        const prefersReduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;
        window.scrollTo({
            top: 0,
            behavior: prefersReduced ? "auto" : "smooth",
        });
    }

    onKey(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.scrollTopSmooth();
        }
    }
}

